import type { PdsOrdersGateway } from '../gateway';
import { searchFakeHistory } from './history.search';
import { buildDeliveredSeed, buildSeedOrders } from './orders.seed';

export const fakeOrdersGateway: PdsOrdersGateway = {
  loadOrders: async () => buildSeedOrders(Date.now()),
  searchHistory: async (query) => searchFakeHistory(query, Date.now()),
  loadDeliveredOrders: async (from, to) =>
    buildDeliveredSeed(Date.now()).filter(
      (order) => order.dueAt >= from && order.dueAt <= to,
    ),
  loadOrdersDue: async (from, to) =>
    [...buildSeedOrders(Date.now()), ...buildDeliveredSeed(Date.now())].filter(
      (order) => order.dueAt >= from && order.dueAt <= to,
    ),
  fetchOrder: async () => null,
  loadOrder: async (orderId) =>
    [...buildSeedOrders(Date.now()), ...buildDeliveredSeed(Date.now())].find(
      (order) => order.id === orderId,
    ) ?? null,
  loadModifications: async () => [],
  setStage: async () => {},
  setItemPrepared: async () => {},
  adjustLines: async () => {},
  loadPickupChoices: async () => [],
  changePickupTime: async () => {},
  cancelOrder: async () => {},
  subscribe: () => () => {},
};
